import { useEffect, useState } from "react";

function canUseFontSet() {
  return typeof document !== "undefined" && Boolean(document.fonts?.load);
}

function isTaylorGothicLoaded() {
  if (!canUseFontSet()) return true;
  try {
    return document.fonts.check("16px TaylorGothic");
  } catch {
    return false;
  }
}

export default function useTaylorGothicReady() {
  const [ready, setReady] = useState(isTaylorGothicLoaded);

  useEffect(() => {
    if (ready) return undefined;
    if (!canUseFontSet()) {
      setReady(true);
      return undefined;
    }

    let cancelled = false;
    const timeoutId = window.setTimeout(() => {
      if (!cancelled) setReady(true);
    }, 1500);

    document.fonts
      .load("16px TaylorGothic")
      .then(() => {
        if (!cancelled) setReady(true);
      })
      .catch(() => {
        if (!cancelled) setReady(true);
      });

    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [ready]);

  return ready;
}
